import router from './router'
import { setDocumentTitle } from './utils'
import storage from './utils/storage'
import defaultConfig from './configs/default.config'
import { useUserStore } from './store'
import { RouteRecordRaw } from 'vue-router'

const whiteList = ['manage-login', 'manage-regist', 'manage-forget', 'manage-forgetpsw', 'wechart-login', 'wechart-login2', 'three', 'manage-store-login']
export default {
  init() {
    console.log('载入路由')
    const userStore = useUserStore()
    router.beforeEach((to, from, next) => {
      to.meta && (typeof to.meta.title !== 'undefined' && setDocumentTitle(`${to.meta.title} - ${defaultConfig.project_title}`))
      // console.log('to',to)
      if (storage.get('BEARER_TOKEN')) {
        // console.log('userStore.menus', userStore.menus)
        if (userStore.menus.length === 0) {
          userStore.onGetUserInfo().then(() => {
            userStore.onGetMenus().then((resp) => {
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              userStore.GenerateRoutes(resp).then((routes: any) => {
                routes.forEach((element: RouteRecordRaw) => {
                  router.addRoute(element)
                })
                next({ ...to, replace: true })
              })
            })
          })
        } else {
          if (to.name === 'manage-login') {
            next({ name: 'manage' })
          }else if(to.name === 'manage-store-login'){
            next({ name: 'manage' })
          } else {
            next()
          }
        }
      } else {
        // console.log('没有token')
        userStore.menus = []
        // 返回登陆
        if (whiteList.includes(to.name as string)) {
          next()
        } else {
          next({ name: 'manage-login' })
        }
      }
    })

    router.afterEach(() => {
      console.log('done')
    })
  }
}